/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description NearbyRentals
 */

import { MenuGroup } from '@zcode-ui/shadz-ui'
import { IS_ZUMPER_RENTALS } from '@zcode/nr-utils'
import React, { useCallback } from 'react'
import { ANALYTICS_EVENT, TRACK_NAVBAR_ACTION } from '../../../constants'
import type { NearbyRentalsSectionProps } from '../../../types'
import { UserMenuBtnRow } from '../SharedComponents'

export const NearbyRentals = ({
  handleSetActiveSubmenu,
  isZumperRentals = IS_ZUMPER_RENTALS,
}: NearbyRentalsSectionProps) => {
  const showAFRMenu = useCallback(
    () =>
      handleSetActiveSubmenu(
        {
          trackAction: TRACK_NAVBAR_ACTION.APARTMENTS_FOR_RENT,
          analyticsEvent: ANALYTICS_EVENT.APARTMENTS_FOR_RENT,
        },
        'smAFR'
      ),
    [handleSetActiveSubmenu]
  )

  const showAmenitiesMenu = useCallback(
    () =>
      handleSetActiveSubmenu(
        {
          trackAction: TRACK_NAVBAR_ACTION.AMENITIES,
          analyticsEvent: ANALYTICS_EVENT.AMENITIES,
        },
        'smAmenities'
      ),
    [handleSetActiveSubmenu]
  )

  const showHFRMenu = useCallback(
    () =>
      handleSetActiveSubmenu(
        {
          trackAction: TRACK_NAVBAR_ACTION.HOUSES_FOR_RENT,
          analyticsEvent: ANALYTICS_EVENT.HOUSES_FOR_RENT,
        },
        'smHFR'
      ),
    [handleSetActiveSubmenu]
  )

  const showRFRMenu = useCallback(
    () =>
      handleSetActiveSubmenu(
        {
          trackAction: TRACK_NAVBAR_ACTION.ROOMS_FOR_RENT,
          analyticsEvent: ANALYTICS_EVENT.ROOMS_FOR_RENT,
        },
        'smRFR'
      ),
    [handleSetActiveSubmenu]
  )

  return (
    <React.Fragment>
      <MenuGroup>
        <div className="flex items-start border-b border-solid border-gray-150 flex-col gap-3 mb-2 pb-4 pt-2 w-full">
          <p className="text-gray-600 text-[9px] font-bold tracking-[1.5px] leading-3 px-4 uppercase">
            Nearby rentals
          </p>
          <div className="flex items-start flex-col w-full">
            {!isZumperRentals && (
              <UserMenuBtnRow onClick={showAFRMenu}>Apartments for rent</UserMenuBtnRow>
            )}
            <UserMenuBtnRow onClick={showHFRMenu}>Houses for rent</UserMenuBtnRow>
            <UserMenuBtnRow onClick={showRFRMenu}>Rooms for rent</UserMenuBtnRow>
            <UserMenuBtnRow data-tesid="user-menu-amenities" onClick={showAmenitiesMenu}>
              Amenities
            </UserMenuBtnRow>
          </div>
        </div>
      </MenuGroup>
    </React.Fragment>
  )
}
